if (!window.VTTCue) {
    window.VTTCue = function (startTime, endTime, text) {
        if (startTime == endTime) endTime = endTime + 0.001;
        return new TextTrackCue(startTime, endTime, text);
    };
}
